export default __webpack_public_path__ + "static/media/presentation.78320492.png";